import {Term} from '../../terms/components/TermsComponent';

export const cookies: Term[] = [
  {
    id: '4.1',
    term:
      "We may use user-entered information in combination with site usage information to help display advertisements relevant to the user's interests and navigation patterns. We may use cookies to help in tracking these patterns but do not store or collect any personal data in combination with user-supplied information. For more information about cookies, please visit All About Cookies.",
  },
];
